export default {
      id: "clock-warning-filled-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#clock-warning-filled",
      toString: function () {
        return this.url;
      }
    }